import React from "react"

export default function Sidebar({children, classes, width})
{       
    const c = classes !== undefined ? ' '+classes : ''
    const w = width !== undefined ? width : 'col-lg-4'
    
    return (
        <div className={'side '+w}>
            <div className={"sidebar"+c}>{children}</div>    
        </div>           
    ) 
}